export enum MeasurementFields {
  LENGTH = "length",
  WIDTH = "width",
  HEIGHT = "height",
  WEIGHT = "weight",
  VOLUME = "volume"
}
